import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { CategoryProps, LeaderProps, PublicPlayerProps, TimerangeProps } from '../../types';
import { LeadersApi } from '../api';
import LeaderCard from './LeaderCard';
import { useColors } from '../../constants/useColors';
import { ActivityIndicator, FlatList } from 'react-native';

type LeaderboardCardProps = {
    category_id:string,
    timerange_id:string,
    player_id?:string,
    onSelectPlayer:(l:LeaderProps, p:PublicPlayerProps) => void,
    onSeeFull: () => void
}

const LeaderboardCard = ({ category_id, timerange_id, player_id, onSeeFull, onSelectPlayer }:LeaderboardCardProps) => {
    const Colors = useColors();
    const [ selected_leader, setSelectedLeader ] = useState<{
        leader?:LeaderProps,
        player?:PublicPlayerProps
    }>({});
    const { leader, player } = selected_leader;

    const [ my_data, setMyData ] = useState<{
            me?:PublicPlayerProps,
            my_leader?:LeaderProps
    }>({});
    const { me, my_leader } = my_data;
    const [ leaders_data, setLeadersData ] = useState<{
        loading:boolean,
        category?:CategoryProps,
        timerange?:TimerangeProps,
        leaders:LeaderProps[],
        players:PublicPlayerProps[],
        offset:number
    }>({
        loading:false,
        leaders: [],
        players:[],
        offset:0
    });
    const { loading, leaders, players, timerange, category } = leaders_data;

    useEffect(() => {
        LeadersApi.setEnvironment();
        if(!timerange_id || !category_id) { return }
        getLeaders(category_id, timerange_id, 0);
    },[timerange_id, category_id, player_id])

    const getLeaders = async(category_id:string, timerange_id: string, page:number) => {
        setLeadersData({ ...leaders_data, loading:true });
        const resp = await LeadersApi.getLeaders(category_id, timerange_id, page, player_id);
        if(!resp){
            setLeadersData({ ...leaders_data, loading:false });
            return alert('Unable to get leaderboard')
        }
        const player_ids = resp.leaders.map(l => l.player_id);
        const players = await LeadersApi.getPlayersByPlayerIds(player_ids);
        if(page == 0 && player_id){
            let me_player = players.find(p => p.player_id == player_id);
            let me_leader = resp.leaders.find(l => l.player_id == player_id);
            setMyData({ me:me_player, my_leader: me_leader });
        }

        setLeadersData({
            ...leaders_data,
            loading:false,
            category: resp.category,
            timerange:resp.timerange,
            leaders:resp.leaders,
            offset: page,
            players
        });
    }
    const renderLeaders = (data:{item:LeaderProps, index:number}) => {
        if(!category){ return <></> }
        const l_player = players.find(p => p.player_id == data.item.player_id);
        if(!l_player){ return <></> }
        const selected = player?.player_id == data.item.player_id ? true: false
        return (
            <View transparent style={{ margin:4, borderWidth:selected?1:0, borderColor:Colors.text.success, borderRadius:12 }}>
                <LeaderCard
                    leader={data.item}
                    player={l_player}
                    category={category}
                    direction='vertical'
                    onSelectLeader={(l, p) => {
                        if(player?.player_id == data.item.player_id){ return setSelectedLeader({}) }
                        setSelectedLeader({ leader: l, player:p })
                    }}
                />
            </View>
        )
    }

    if(!timerange || !category){ return <></> }
    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Leaders by {category.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{timerange.name} ({timerange.order_minimum} Bets Minimum)</Text>
                </View>
                <Button 
                    title='See Full Leaderboard'
                    style={{ padding:10 }}
                    type='text'
                    onPress={() => onSeeFull()}
                />
            </View>
            <View style={{ flex:1, padding:10 }}>
                <View style={{ flexDirection:'row' }}>
                    {my_leader && me ?
                    <View style={{ margin:4 }}>
                    <LeaderCard
                        leader={my_leader}
                        player={me}
                        onSelectLeader={() => console.log('')}
                        direction='vertical'
                        category={category}
                        
                    />
                    </View>
                    :<></>}
                    {loading ?
                    <ActivityIndicator style={{ padding:10, alignSelf:'center' }} color={Colors.text.h1} size='large' />
                    :<></>}
                    <View style={{ flex:1, borderLeftWidth:1, borderColor:Colors.borders.light }}>
                        <FlatList
                            key={'leader_list'}
                            data={leaders}
                            showsHorizontalScrollIndicator={false}
                            horizontal
                            keyExtractor={(item) => item.leader_id.toString()}
                            renderItem={renderLeaders}
                        />
                    </View>
                </View>
                {leader && player ?
                <View style={{ margin:5 }}>
                    <LeaderCard
                        leader={leader}
                        player={player}
                        category={category}
                        show_view_profile
                        onSelectLeader={onSelectPlayer}
                    />
                </View>
                :<></>}
            </View>
        </View>
    )
}

export default LeaderboardCard